import {
  FloorPlan,
  type FloorPlanTablesRenderer,
} from '@components/floorPlan/FloorPlan';
import { interactiveFloorPlanTablesRendererFactory } from '@components/floorPlan/floorPlanTablesRendererFactory';
import type { FloorPlanTableData } from '@shared/types/floorPlans';
import { useRef } from 'react';
import type { ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';
import styles from './EditMultiTableReservationFloorPlan.scss';

interface EditMultiTableReservationFloorPlanProps {
  backgroundSrc?: string;
  tables: FloorPlanTableData[];
  selectedFloorPlanTables: FloorPlanTableData[];
  handleTableOnClick: (table: FloorPlanTableData) => void;
}

export const EditMultiTableReservationFloorPlan = ({
  backgroundSrc,
  tables,
  selectedFloorPlanTables,
  handleTableOnClick,
}: EditMultiTableReservationFloorPlanProps) => {
  const zoomRef = useRef<ReactZoomPanPinchRef | null>(null);

  const calculateIsHighlighted = (
    floorPlanTable: FloorPlanTableData,
  ): boolean => selectedFloorPlanTables.some((t) => t.id === floorPlanTable.id);

  const floorPlanTablesRenderer: FloorPlanTablesRenderer =
    interactiveFloorPlanTablesRendererFactory<FloorPlanTableData>({
      calculateIsHighlighted,
      calculateIsSelectable: () => true,
      handleTableOnClick,
      tables,
      showName: true,
    });

  return (
    <div className={styles.floorPlanContainer}>
      <div className={styles.floorPlan}>
        <FloorPlan
          backgroundSrc={backgroundSrc}
          floorPlanTablesRenderer={floorPlanTablesRenderer}
          ref={zoomRef}
        />
      </div>
    </div>
  );
};
